import { Injectable } from '@angular/core';
import { BaseSignalStore } from '@core/state/base-store';
import { SuccessionFileDto, SuccessionPhase } from '@shared/models/dto/api-dtos';

export interface SuccessionFilesState {
  items: SuccessionFileDto[];
  totalCount: number;
  currentPage: number;
  pageSize: number;
  filters: {
    phase?: SuccessionPhase;
    notaryOfficeId?: number;
    filter?: string;
    old2y?: boolean;
  };
}

@Injectable({ providedIn: 'root' })
export class SuccessionFilesStore extends BaseSignalStore<SuccessionFilesState> {
  constructor() {
    super({
      items: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 20,
      filters: {}
    });
  }

  // selectors
  readonly items = this.select(state => state.items);
  readonly totalCount = this.select(state => state.totalCount);
  readonly currentPage = this.select(state => state.currentPage);
  readonly pageSize = this.select(state => state.pageSize);
  readonly filters = this.select(state => state.filters);
  readonly isEmpty = this.select(state => state.items.length === 0);

  // updaters
  setItems(items: SuccessionFileDto[], totalCount?: number) {
    this.setState({ items, totalCount: totalCount ?? items.length });
  }
  appendItems(
    items: SuccessionFileDto[],
    pagination: { page: number; pageSize: number; totalCount?: number }
  ): void {
    const current = this.state();
    items.forEach((item) => {
      current.items.push(item);
    })

    this.setState({
      items: current.items,
      currentPage: pagination.page,
      pageSize: pagination.pageSize,
      totalCount: pagination.totalCount ?? current.totalCount
    });
  }
  setFilters(filters: Partial<SuccessionFilesState['filters']>) {
    this.setState({ filters: { ...this.state().filters, ...filters } });
  }

  setPagination(page: number, pageSize: number) {
    this.setState({ currentPage: page, pageSize });
  }
  resetState(): void {
    this.setState({
      items: [],
      totalCount: 0,
      currentPage: 1
    });
  }

}


